import { FormHelperText, FormLabel, Stack } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { useProductsTFunction } from '@retail/products/i18n';
import { Control, useController } from 'react-hook-form';
import { DateRangeSchema, inputSx } from '../DateSchema';

interface Props {
  control: Control<DateRangeSchema>;
}

export function SharedTagDates({ control }: Props) {
  const t = useProductsTFunction();
  const fromDate = useController({ name: 'fromDate', control });
  const toDate = useController({ name: 'toDate', control });

  return (
    <Stack flexDirection="row" alignItems="flex-start" gap={5}>
      <Stack flexDirection="row" alignItems="center" gap={1.5}>
        <FormLabel
          sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}
          error={!!fromDate.fieldState.error}
          required
        >
          {t('products.mgItem.fromDate.label')}
        </FormLabel>
        <Stack gap={0.5}>
          <DatePicker
            {...fromDate.field}
            minDate={new Date()}
            maxDate={toDate.field.value ?? undefined}
            format="dd/MM/yyyy"
            slotProps={{ textField: { sx: { ...inputSx, width: 180 }, helperText: undefined } }}
          />
          {!!fromDate.fieldState.error && (
            <FormHelperText sx={{ color: 'warning.main', m: 0 }}>
              {fromDate.fieldState.error.message}
            </FormHelperText>
          )}
        </Stack>
      </Stack>

      <Stack flexDirection="row" alignItems="center" gap={1.5}>
        <FormLabel sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}>
          {t('products.mgItem.toDate.label')}
        </FormLabel>
        <DatePicker
          {...toDate.field}
          value={toDate.field.value ?? null}
          minDate={fromDate.field.value ?? new Date()}
          format="dd/MM/yyyy"
          slotProps={{
            field: { clearable: true },
            textField: { sx: { ...inputSx, width: 180 }, helperText: undefined },
          }}
        />
      </Stack>
    </Stack>
  );
}
